export default {
    clickAndCollect: 'clickAndCollect',
    clickAndBuy: 'clickAndBuy',
    clickAndDeliver: 'clickAndDeliver',
    clickAndReserve: 'clickAndReserve',
};
